var map = {
	"./DriverOff.png": "50d4",
	"./DriverOn.png": "4460",
	"./InformaOff.png": "298b",
	"./InformaOn.png": "8a7d",
	"./Logo.png": "5684",
	"./NavMenu.png": "a274",
	"./SwipeOff.png": "83ef",
	"./SwipeOn.png": "e32a",
	"./accounicon.png": "5876",
	"./analysisicon.png": "f132",
	"./backgroundicon.png": "dd8b",
	"./batteryicon.png": "0560",
	"./bg.png": "3f6e",
	"./bg1.png": "72dd",
	"./bgZj.png": "7c6e",
	"./bomb-bg.png": "ec78",
	"./car.png": "1437",
	"./carNumber.png": "2685",
	"./carTotal.png": "4c9a",
	"./carWorkOff.png": "e7d2",
	"./carWorkOn.png": "c444",
	"./caricon.png": "3f66",
	"./china.png": "6666",
	"./close.png": "d991",
	"./closeB.png": "78b8",
	"./diesel .png": "7269",
	"./driveicon.png": "1c912",
	"./electric.png": "2d44",
	"./homeicon.png": "63c0",
	"./imgBg.png": "dbb1",
	"./insureTotal.png": "2be6",
	"./iosImg.png": "115f",
	"./leftDown.png": "17f5",
	"./leftDownZj.png": "fef1",
	"./leftUp.png": "2610",
	"./leftUpZj.png": "a507",
	"./mapDisable.png": "6728",
	"./mapOff.png": "fb78",
	"./mapOn.png": "7ea6",
	"./masterKongBg.png": "6140",
	"./masterKongFour.png": "11fa",
	"./masterKongOne.png": "6943",
	"./masterKongThree.png": "60f17",
	"./masterKongTitle.png": "dd59",
	"./masterKongTitleBg.png": "49ac",
	"./masterKongTwo.png": "ff1a",
	"./menucar.png": "6b9a",
	"./menudata.png": "c504",
	"./menupro.png": "e029",
	"./menuset.png": "03f5",
	"./menuword.png": "069e",
	"./newCenterBg.png": "3893",
	"./newMoney.png": "f70d",
	"./off.png": "a303",
	"./on.png": "2652",
	"./onIcon.png": "bf10",
	"./open.png": "b93d",
	"./openB.png": "cfa1",
	"./person.png": "e914",
	"./platicon.png": "17ae",
	"./qiu.png": "02ec",
	"./red.png": "5be9",
	"./right.png": "0f2a",
	"./rightCenter.png": "8ed3",
	"./rightUp.png": "c8cc",
	"./safeicon.png": "d82c",
	"./scanImg.png": "b8bf",
	"./terminalOff.png": "3827",
	"./terminalOn.png": "5b2a",
	"./title.png": "35cc",
	"./titleBg.png": "326d",
	"./upload.png": "894f",
	"./warm.png": "e236",
	"./zhengfu.png": "7186",
	"./zjScan.png": "29e3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";